export default "__VITE_ASSET__ClZJY$Ru__"